import * as React from 'react';
import { Label } from 'semantic-ui-react';
export var BetaLabel = function () { return (<Label color='black' size='mini' style={{ margin: '0 0.3rem', height: '1.5rem' }}>
		BETA
	</Label>); };
